import { Pill } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

import { formatWorkerTypesLabel } from "../../../utils/formatWorkerTypesLabel";

interface PlacementWorkerTypePillProps {
  workerTypes: string[];
  blurred?: boolean;
}

export function PlacementWorkerTypePill(props: PlacementWorkerTypePillProps) {
  const { workerTypes, blurred = false } = props;

  const workerTypesLabel = formatWorkerTypesLabel(workerTypes);

  return (
    <Pill
      label={
        <Box component="span" style={{ filter: blurred ? "blur(8px)" : undefined }}>
          {workerTypesLabel}
        </Box>
      }
      variant="outlined"
      size="small"
      backgroundColor={(theme) => theme.palette.background.tertiary}
      color={(theme) => theme.palette.text.secondary}
    />
  );
}
